export enum MenuType
{
    Digital = 0,
    Physical = 1,
    External = 2,
}